import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';

import { Page } from '@nearst/ui';

// components
import AnalyticsWrapper from '@components/AnalyticsWrapper';
import ErrorBoundary from '@components/ErrorBoundary';
import LoadingContainer from '@components/LoadingContainer';
import MyShopNavigation from '@components/MyShopNavigation';
import PrivateRoute from '@components/PrivateRouteComponent';
import Sidebar from '@components/Sidebar';
import { ChatSidebar } from '@components/ChatSidebar';
import { MobileChatFab } from '@components/ChatSidebar/MobileChatFab';

// services
import { ShopProvider, useShop } from '@services/ShopProvider';
import { UpgradeModalProvider } from '@services/UpgradeProvider';
import { InsightsDateProvider } from '@services/InsightsDateProvider';
import { ChatProvider } from '@services/ChatProvider';
import { getLocalFlags } from '@services/featureFlags/useFlags';
import ScrollToTop from '@utils/ScrollToTop';
import UpdatePopup from '@components/UpdatePopup';

// Inner component to access ShopProvider context
const ChatProviderWrapper = ({ children, showChat }) => {
	const { shop } = useShop();
	const { user } = useUser();

	if (!showChat) return children;

	return (
		<ChatProvider mode="general" currentShop={shop} userId={user?.id}>
			{children}
		</ChatProvider>
	);
};

export const RootLayout = () => {
	const location = useLocation();
	const showChat = getLocalFlags().includes('chat');

	return (
		<PrivateRoute>
			<ShopProvider>
				<ChatProviderWrapper showChat={showChat}>
					<AnalyticsWrapper>
						<InsightsDateProvider>
							<UpgradeModalProvider>
								<ScrollToTop />
								<UpdatePopup />
								<Sidebar.Layout>
									<MyShopNavigation />
									{showChat && <ChatSidebar />}
									<Page.Main fallback={<LoadingContainer />}>
										<ErrorBoundary>
											<Outlet key={location.pathname} />
										</ErrorBoundary>
									</Page.Main>
								</Sidebar.Layout>
								{showChat && <MobileChatFab />}
							</UpgradeModalProvider>
						</InsightsDateProvider>
					</AnalyticsWrapper>
				</ChatProviderWrapper>
			</ShopProvider>
		</PrivateRoute>
	);
};
